@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (canSendLinks) {
  <p-confirmdialog icon="pi pi-envelope" [style]="{width: '480px'}"></p-confirmdialog>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div style="display:flex; align-items:flex-end; flex-wrap:wrap; column-gap:20px; row-gap:12px; margin-bottom:20px;">
      <h3 style="margin:0; align-self:center; white-space:nowrap;" i18n>Outstanding Balances for period: </h3>
      <div>
        <label style="display:block; margin-bottom:4px;">From Date:</label>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="FromDate" (onSelect)="fromDateChanged()" (onInput)="fromDateChanged()" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" [inputStyle]="{'width':'130px'}"></p-datepicker>
      </div>
      <div>
        <label style="display:block; margin-bottom:4px;">To Date:</label>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="ToDate" [minDate]="FromDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" [inputStyle]="{'width':'130px'}"></p-datepicker>
      </div>
      <div>
        <label style="display:block; margin-bottom:4px;">Tags:</label>
        <p-multiselect [options]="tags" optionLabel="name" [(ngModel)]="chosentags" display="chip" placeholder="Select Tag(s)" [style]="{'width':'200px'}">
          <ng-template let-value #selecteditems>
            @for (tag of chosentags; track tag) {
              <span>
                <p-chip class="mr-2" label="{{tag.name}}" [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px' }">
                </p-chip>
              </span>
            }
            @if (!chosentags || chosentags.length === 0) {
              <div class="country-placeholder"> Select Tag(s) </div>
            }
          </ng-template>
        </p-multiselect>
      </div>
      <div style="display:flex; gap:8px;">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto" style="background-color: #22C55E;border-color: #22C55E;" (click)="doneDate()">
          Go
        </button>
        @if (ListBookings) {
          <button
            type="button"
            pButton
            pRipple
            (click)="OutstandingTable.exportCSV()"
            pTooltip="Export to CSV"
            tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
          }
        </div>
      </div>
      <div class="surface-card p-4 shadow-2 border-round">
        <p-table #OutstandingTable
          [columns]="cols"
          [value]="ListBookings"
          responsiveLayout="scroll">
          <ng-template #header>
            <tr>
              <th width="8%">Sales ID</th>
              <th width="8%">Start Date</th>
              <th width="6%">Start</th>
              <th width="10%">Name</th>
              <th width="14%">Package</th>
              <th width="18%">Admissions</th>
              <th style="text-align: right;" width="5%">Guests</th>
              <th style="text-align: right;" width="6%">Total</th>
              <th style="text-align: right;" width="6%">O/S</th>
              <th width="9%">Phone</th>
              <th width="14%">Email</th>
              @if (canSendLinks) {
                <th width="12%">Payment Link</th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'"
              onmouseout="this.style.backgroundColor=this.originalstyle;"
              style="cursor:pointer;"
              (click)="editdata(rowData.bookingId)">
              <td>{{rowData.bookingIdHR}}</td>
              <td>{{rowData.startTime | date:'dd/MM/yy' : 'UTC'}}</td>
              <td>{{rowData.startTime | date:'HH:mm' : 'UTC'}}</td>
              <td>{{rowData.name}}</td>
              <td>{{rowData.packageName}}</td>
              <td>{{rowData.admissionsText}}</td>
              <td style="text-align: right;">{{rowData.guests}}</td>
              <td style="text-align: right;">{{rowData.total | currency: (rowData.currency || CurrencySymbol)}}</td>
              <td style="text-align: right;"><span style="color: Red; font-weight: bold;">{{rowData.outstanding | currency: (rowData.currency || CurrencySymbol)}}</span></td>
              <!-- The two things needed to chase the money. Links, so a click rings or writes
              straight from the report - stopped from also opening the booking. -->
              <td>@if (rowData.phone) {
                <a href="tel:{{rowData.phone}}" (click)="$event.stopPropagation()">{{rowData.phone}}</a>
              }</td>
              <td>@if (rowData.email) {
                <a href="mailto:{{rowData.email}}" (click)="$event.stopPropagation()">{{rowData.email}}</a>
              }</td>
              @if (canSendLinks) {
                <td style="white-space: nowrap;">
                  <button pButton pRipple type="button" class="p-button-warn p-button-sm"
                    [loading]="sendingTo == rowData.bookingId"
                    [disabled]="!rowData.email"
                    (click)="sendPaymentLink(rowData, $event)"><span class="p-button-icon p-button-icon-left" [ngClass]="(sendingTo == rowData.bookingId) ? 'p-button-loading-icon pi pi-spin pi-spinner' : 'pi pi-envelope'" aria-hidden="true"></span><span class="p-button-label">Send Payment Link</span></button>
                    <!-- When one last went, so nobody is chased twice in a morning. -->
                    @if (rowData.linkSent) {
                      <small class="block mt-1" [style.color]="rowData.linkJustSent ? '#16a34a' : '#6c757d'">
                        @if (rowData.linkJustSent) {
                          <span class="pi pi-check" style="margin-right:4px;"></span>
                          }Sent {{rowData.paymentlinksentdateCSV}}
                        </small>
                      }
                      @if (!rowData.linkSent) {
                        <small class="block mt-1" style="color:#6c757d;">Not sent</small>
                      }
                    </td>
                  }
                </tr>
              </ng-template>
              <ng-template #footer>
                @if (ListBookings != null && ListBookings.length > 0) {
                  <tr>
                    <td colspan="5"><b>{{ListBookings.length}} booking{{ListBookings.length == 1 ? '' : 's'}} with a balance outstanding</b></td>
                    <td style="text-align: right;"><b>Total</b></td>
                    <td style="text-align: right;"><b>{{guests}}</b></td>
                    <td style="text-align: right;"><b>{{total | currency: CurrencySymbol}}</b></td>
                    <td style="text-align: right;"><b style="color: Red;">{{outstanding | currency: CurrencySymbol}}</b></td>
                    <td></td>
                    <td></td>
                    @if (canSendLinks) {
                      <td></td>
                    }
                  </tr>
                }
                @if (ListBookings == null || ListBookings.length == 0) {
                  <tr>
                    <td style="text-align: center;" colspan="12">
                      No bookings in the selected date range have a balance outstanding.
                    </td>
                  </tr>
                }
              </ng-template>
            </p-table>
          </div>
        </div>
      }
